// Libs
import React from "react";
import { PhotoIcon } from "@heroicons/react/24/outline";

// Local
import HeadingOne from "../../components/HeadingOne";
import StandaloneEmailImagesManager from "../../components/EmailMarketing/StandaloneEmailImagesManager";

interface Props {
  siteKey: string;
}

export default function EmailImagesPage({ siteKey }: Props) {
  return (
    <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
      <div className="mb-6">
        <HeadingOne>
          <div className="flex items-center gap-3">
            <PhotoIcon className="h-8 w-8 text-indigo-600" />
            Marketing Images
          </div>
        </HeadingOne>
        <p className="mt-2 text-gray-600">
          Upload and manage images for your marketing campaigns. These images
          can be inserted into your email templates and accessed via URL.
        </p>
      </div>

      <StandaloneEmailImagesManager siteKey={siteKey} />
    </div>
  );
}
